import Text from 'components/Text/Text';
import React, { useContext } from 'react';
import DataController from 'components/DataController/DataController';
import { IItemVideoCategory } from 'types';
import { VideoCategoriesContext, IVideoCategoriesContext } from '../../../videoCategoriesState/videoCategoriesContext';
import classNames from 'classnames';
import style from './Item.module.scss';

interface IItem {
	data: IItemVideoCategory;
	index: number;
}

const Item: React.FC<IItem> = ({ data, index }) => {
	const { setIDForDeletion } = useContext<IVideoCategoriesContext>(VideoCategoriesContext);

	const categoriesRowClasses = classNames(style.row, style.categories);
	const actionRowClasses = classNames(style.row, style.action);

	const handleSetIdForDeletion = () => {
		setIDForDeletion(data.id);
	};

	return (
		<div data-test={`Item-${index}`} className={style.container}>
			<Text className={categoriesRowClasses} translationKey={data.name} withTooltip={true} />
			<div className={actionRowClasses}>
				<DataController
					onClickDelete={handleSetIdForDeletion}
					URLWithIDToEdit={`/entertainment/videos/categories/edit?categoryID=${data.id}`}
					size="smallBtn"
				/>
			</div>
		</div>
	);
};

export default Item;
